module.exports = __webpack_public_path__ + "static/media/PM6.c0a8f39f.JPG";